<template>
    <a target="_blank" :href="googleAppStoreLink" @click="clickButton()"><img alt="Download Wotive gym workout tracker app android app store" src="../../assets/landing-page/googleplay.svg" /></a>
</template>

<script>
import { GOOGLE_PLAY_STORE_LINK } from '@/constants';

export default {
  name: "GoogleButton",

  computed: {
    googleAppStoreLink() {
      return GOOGLE_PLAY_STORE_LINK;
    },
  },

  methods: {
    clickButton() {
      console.log("clicking google");
      gtag('event', 'conversion', {'send_to': 'AW-10794836056/EyLACOuKtuoZENjAsJso'});
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

img {
    height: 40px;
    margin-right: 8px;
}
</style>